import { apiRequest } from "../index";

export const getUserById = async () => {
  return apiRequest(`/api/admin/dashboard/user`, "GET");
};

export const getRestaurantOrders = async ({page , limit}) => {
  return apiRequest(`/api/admin/dashboard/restaurant/orders?page=${page}&limit=${limit}`, "GET");
};

export const getDashboardInsights = async () => {
  return apiRequest(`/api/admin/dashboard/insights`, "GET");
};

export const getUserReports = async () => {
  return apiRequest(`/api/admin/dashboard/user/reports`, "GET");
};

export const getCommissionRate = async () => {
  return apiRequest(`/api/admin/dashboard/commission/rate`, "GET");
};

export const getUsers = async ({ page = 1, limit = 10, search = "" } = {}) => {
  return apiRequest(`/api/admin/dashboard/users?page=${page}&limit=${limit}&search=${search}`, "GET");
};
